import script from "./OffcanvasComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./OffcanvasComponent.vue?vue&type=script&lang=ts&setup=true"

import "./OffcanvasComponent.vue?vue&type=style&index=0&id=0057462e&lang=css"

const __exports__ = script;

export default __exports__